/* eslint-disable no-useless-concat */
import api from "./api";
import {  Dato_Operario} from "src/utils";
 
const Operarios = {

  async listarOperarios(){
  const registro_Operario: Dato_Operario[] = [];

    await api.get(`/usuario/operarios`).then(
      (response) => {
        const operarios = response.data.datos;
        operarios.forEach((registro: Dato_Operario) => {
          registro_Operario.push({
            cargo: registro.cargo,
            legajo: registro.legajo,
            nombre: registro.nombre
          });
        });
      },
      (error) => error
    );

    return registro_Operario;
  },

  // Buscar operarios en backend usando query params (evita traer toda la nómina).
  // Backend: GET /usuario/operarios?legajo=...&nombre=...
  // Nota: el endpoint aplica permisos (no accesible por cargo operario).
  async buscarOperarios(params: { nombre?: string; legajo?: string }) {
    try {
      const qs = new URLSearchParams();
      if (params.legajo) qs.set('legajo', String(params.legajo));
      if (params.nombre) qs.set('nombre', String(params.nombre));

      const { data } = await api.get(`/usuario/operarios?${qs.toString()}`);
      const operarios = (data?.datos || []) as Array<any>;

      return operarios.map((registro: any) => ({
        cargo: registro.cargo,
        legajo: registro.legajo,
        nombre: registro.nombre,
      })) as Dato_Operario[];
    } catch {
      return [] as Dato_Operario[];
    }
  },

  // Listar evaluables para Evaluación de Desempeño (operarios con antigüedad mínima y supervisores)
  async listarEvaluables(params: { tipo: "OPERARIO" | "SUPERVISOR"; q?: string }) {
    try {
      const qs = new URLSearchParams(); // construir query string tipada
      qs.set("tipo", params.tipo); // enviar tipo requerido por el backend
      if (params.q) qs.set("q", String(params.q)); // enviar búsqueda opcional (legajo o nombre/apellido)
      const { data } = await api.get(`/usuario/evaluables?${qs.toString()}`); // invocar endpoint dedicado
      return (data?.datos || []) as Array<{ legajo: number; nombre: string; cargo: string; fecha_ingreso?: string }>; // devolver lista normalizada
    } catch {
      return [] as Array<{ legajo: number; nombre: string; cargo: string; fecha_ingreso?: string }>; // fallback seguro
    }
  },

  // Listar operarios y supervisores activos (busqueda por legajo o nombre)
  // incluirCapacitadores: si true, también devuelve cargos 'CAPACITADOR TECNICO'
  async listarOperariosSupervisores(q?: string, incluirCapacitadores?: boolean) {
    try {
      const qs = new URLSearchParams();
      if (q) qs.set("q", String(q));
      if (incluirCapacitadores) qs.set("incluir_capacitadores", "1");
      const suffix = qs.toString() ? `?${qs.toString()}` : "";
      const { data } = await api.get(`/usuario/operarios-supervisores${suffix}`);
      return (data?.datos || []) as Array<{ legajo: number; nombre: string; cargo: string }>;
    } catch {
      return [] as Array<{ legajo: number; nombre: string; cargo: string }>;
    }
  },

  // Nuevo: listar fiscales desde jefatura (rápido y simple: usar /usuario/operarios filtrando por 'FISCALIZADOR A')
  async listarFiscalesJefatura(search?: string){
    try{
      const { data } = await api.get(`/usuario/operarios`);
      const todos = (data?.datos || []) as Array<any>;
      let fiscales = todos
        .filter((o: any) => String(o.cargo || "").trim().toUpperCase() === "FISCALIZADOR A")
        .map((o: any) => ({ id: String(o.id ?? o.legajo ?? ""), nombre: String(o.nombre ?? o.usuario ?? ""), cargo: String(o.cargo ?? "") }))
        .filter((o: { id: string; nombre: string; cargo: string }) => o.id && o.nombre);
      if (search) {
        const texto = String(search).toLowerCase();
        fiscales = fiscales.filter(f => f.nombre.toLowerCase().includes(texto));
      }
      return fiscales as Array<{ id: number|string; nombre: string; cargo: string }>;
    } catch {
      return [] as Array<{ id: number|string; nombre: string; cargo: string }>;
    }
  },

  // Obtener un operario por id/legajo para datos adicionales (ej.: fecha de ingreso, cargo actualizado)
  async obtenerPorId(id: string | number){
    try{
      const { data } = await api.get(`/usuario/operarios/${id}`); // endpoint esperado en backend
      return data?.datos || null; // devolver datos normalizados o null
    } catch {
      return null; // en caso de error devolvemos null para no romper el flujo del front
    }
  },

async diaLibreOperario(datos){
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return  api.post(`/dia_libre`, datos, config)
},
async crearDiaLibre(datos){
  const config = {
    headers: {
      'Content-Type': 'application/json'
    }
  };
  return  api.post(`/crear_dialibre`, datos, config)
},

}

export default Operarios;
